import React, { useContext } from 'react'
import { EPCRContext } from '../../EPCR'
import { TextField } from '@mui/material'

const HSAdditionalNotes = () => {
  const { formValues, handleChange } = useContext(EPCRContext)
  return (
    <TextField
      multiline
      label="Additional Notes for Event Organiser"
      helperText="Do not include patient identifiable information here"
      value={formValues?.incident?.healthSafetyAdditionalNotesForOrganiser}
      onChange={(e) =>
        handleChange({
          moduleName: 'incident',
          field: 'healthSafetyAdditionalNotesForOrganiser',
          value: e.target.value,
        })
      }
    />
  )
}

export default HSAdditionalNotes
